import Styleguide from "@store/Framework/Types/Styleguide";

const icon: Styleguide["icon"] = {};

export default icon;
